import socketIOClient from "socket.io-client";
import sailsIOClient from "sails.io.js";
import { store } from "../redux/storeConfig/store";
import {
  notificationsApi,
  unreadNotificationCountApi,
} from "../redux/actions/api/apiAction";
// import { toastr } from "react-redux-toastr";
// import { store } from "../redux/storeConfig/store";
// import {
//   setNotificationAlert,
//   setNotification,
//   addNotification
// } from "../redux/actions/notificationAction";
// import { history } from "../app/AppRouter";

// import notifyImg from "../assets/images/notify.ico";
// making hybrid socket with native socket and sail socket
var io = sailsIOClient(socketIOClient);

//specify connection url it will auto connect no need to
// io.sails.url = 'http://localhost:1320';
// const mainUrl = 'http://localhost:1320';
// io.sails.url = 'https://api.connecttofit.zignuts.dev';
// io.sails.url = "http://localhost:1337";
io.sails.url = "https://api.connecttofit.com";
io.sails.environment = "production";

//io.sails.url = "http://52.52.174.83:1337";

// RS: Not sure what this file is for.
// io.sails.url = "http://cmsbackenddev.us-east-2.elasticbeanstalk.com"

// export const unsubscribeToAircraft = async id => {
//   io.socket.get(`/v1/unsubscribe/aircrafts/${id}`, function(resData) {
//     console.log(resData);
//   });
//   io.socket.off("aircraft", function(resData) {
//     console.log(resData);
//   });
// };

// export const subscribeToAircraft = data => {
//   // console.log("function of subscribe to air", data);
//   io.socket.get(`/v1/subscribe/aircrafts/${data.id}`, function(resData) {
//     console.log(resData);
//     store.dispatch(setNotification(resData.notifications));
//   });
// };
// Connection handlers
io.socket.on('connect', () => {
  console.log('Socket >>>>> Connected successfully:', {
    // socketId: this.socket.id,
    time: new Date().toISOString()
  });

  store.dispatch({ 
    type: "SET_GATE_CONNECTION_STATUS",
    payload: { data: true }
  });
});
io.socket.on('disconnect', (reason) => {
  console.log('Socket >>>>> Disconnected:', {
    reason,
    time: new Date().toISOString()
  });
  
  store.dispatch({ 
    type: "SET_GATE_CONNECTION_STATUS",
    payload: { data: false }
  });
});

io.socket.on('connect_error', (error) => {
  console.error('Socket >>>>> Connection error:', {
    error: error.message,
    time: new Date().toISOString()
  });
  
  store.dispatch({ 
    type: "SET_CONNECTION_ERROR",
    payload: { data: error.message }
  });
});
export const subscribeToMember = (data) => {
  // console.log("function of subscribe to air", data);
  // console.log('subscribeToMember');
  io.socket.get(`/join/${data}`, function (resData, data) {
    // console.log('resData', resData);
    // console.log('data', data);
    // store.dispatch(setNotification(resData.notifications));
  });
};

export const joinGym = (gymId) => {
  // Join the gym room
  console.log('Joining gym room:', `gym-${gymId}`);
  
  // First, remove any existing listeners to prevent duplicates
  io.socket.off(`gym-${gymId}`);
  io.socket.off('MEMBER_ACCESS');
  
  // Join the gym room
  io.socket.get(`/joinGym/${gymId}`, function (resData, data) {
    console.log('Joined gym room response:', resData);
    
    // Set up listener for MEMBER_ACCESS events
    io.socket.on('MEMBER_ACCESS', function(data) {
      console.log('Socket >>>>> Member access event received:', {
        data,
        time: new Date().toISOString()
      });
      
      store.dispatch({ 
        type: "SET_MEMBER_ACCESS",
        payload: { data }
      });
    });

    // Also listen on the room-specific channel
    io.socket.on(`gym-${gymId}`, function(data) {
      console.log('Received gym room event:', data);
      
      if (data.type === 'MEMBER_ACCESS') {
        console.log('Socket >>>>> Member access event from room:', {
          data,
          time: new Date().toISOString()
        });
        
        store.dispatch({ 
          type: "SET_MEMBER_ACCESS",
          payload: { data }
        });
      }
    });
  });
};

export const getNotifications = (data) => {
  // console.log("GET NOTIFICATION CALLED");
  //   io.socket.on('CLASS_BOOKED', function (msg) {
  //     console.log('Inside hello');
  //     console.log(msg);
  //     let newNotification = {
  //       id: Math.random(),
  //       title: `Great!! Notification enabled`,
  //       message: `You have sucessfully enabled notification`,
  // userId: data.id,
  // createdAt: new Date().getTime(),
  // };
  // toastr.info("Aircraft Updated", newNotification.message);
  // if (!('Notification' in window)) {
  //   alert('This browser does not support desktop notification');
  // }

  // // Let's check whether notification permissions have already been granted
  // else if (Notification.permission === 'granted') {
  //   // If it's okay let's create a notification
  //   let notification = new Notification(newNotification.title, {
  //     // icon: notifyImg,
  //     body: newNotification.message,
  //   });
  //   notification.onclick = () => {
  //     window.focus();
  //     notification.close();
  //   };
  // }

  // // Otherwise, we need to ask the user for permission
  // else if (Notification.permission !== 'denied') {
  //   Notification.requestPermission().then(function (permission) {
  //     // If the user accepts, let's create a notification
  //     if (permission === 'granted') {
  //       let notification = new Notification(newNotification.title, {
  //         // icon: notifyImg,
  //         body: newNotification.message,
  //       });
  //       notification.onclick = () => {
  //         window.focus();
  //         notification.close();
  //       };
  //     }
  //   });
  // }
  //   }
  //   );

  let newNotification = {};
  io.socket.off("CLASS_ASSIGNED").on("CLASS_ASSIGNED", function (data) {
    // console.log(data.data);
    newNotification = data.data;
    fireNotification(newNotification);
  });
  io.socket.off("CLASS_UPDATED").on("CLASS_UPDATED", function (data) {
    // console.log(data.data);
    newNotification = data.data;
    fireNotification(newNotification);
  });
  io.socket.off("PLAN_EXPIRED").on("PLAN_EXPIRED", function (data) {
    // console.log(data.data);
    newNotification = data.data;
    fireNotification(newNotification);
  });
  io.socket.off("BIRTHDAY").on("BIRTHDAY", function (data) {
    // console.log(data.data);
    newNotification = data.data;
    fireNotification(newNotification);
  });
  const fireNotification = async (newNotification) => {
    await store.dispatch(notificationsApi(1, 10));
    await store.dispatch(unreadNotificationCountApi());
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification");
    }

    // Let's check whether notification permissions have already been granted
    else if (Notification.permission === "granted") {
      // If it's okay let's create a notification
      let notification = new Notification(newNotification.title, {
        icon: newNotification.avatar,
        body: newNotification.title,
      });
      notification.onclick = () => {
        window.focus();
        notification.close();
      };
    }

    // Otherwise, we need to ask the user for permission
    else if (Notification.permission !== "denied") {
      Notification.requestPermission().then(function (permission) {
        // If the user accepts, let's create a notification
        if (permission === "granted") {
          let notification = new Notification(newNotification.title, {
            icon: newNotification.avatar,
            body: newNotification.title,
          });
          notification.onclick = () => {
            window.focus();
            notification.close();
          };
        }
      });
    }

    // let notification = new Notification(newNotification.title, {
    //   icon: newNotification.avatar,
    //   body: newNotification.title,
    // });
    // notification.onclick = () => {
    //   window.focus();
    //   notification.close();
    // };
  };
};
export default io;
